import Vue from "vue"
import api from '@/api'
const state = {
  searchLoading: false,
  openAiSearchResult:[],
	solutions:[],
	serviceRequests:[],
  openAiSolution:'',
	openAiQuestions:'',
	userQuery:'',
	estimateQuestion:'',
  type:"",
  loadingNum:0
}
const getters = {
  getSearchLoading(state) { return state.searchLoading },
  getOpenAiSearchResult(state) { return state.openAiSearchResult },
  getOpenAiSolution(state) { return state.openAiSolution },
	getOpenAiQuestions(state) { return state.openAiQuestions },
}

const mutations = {
	setSearchLoading(state, searchLoading) {
    state.searchLoading = searchLoading;
  },
	setOpenAiSearchResult(state, openAiSearchResult) {
    state.openAiSearchResult = openAiSearchResult;
    if(state.openAiSearchResult[0]){
      Vue.set(state.openAiSearchResult,0,state.openAiSearchResult[0]);
    }
  },
	setOpenAiSolution(state,openAiSolution){
		state.openAiSolution = openAiSolution
	},
	setUserQuery(state,userQuery) {
		state.userQuery = userQuery
	},
	setOpenAiQuestions(state,openAiQuestions){
		state.openAiQuestions = openAiQuestions
	},
	setSolutions(state,solutions){
		state.solutions = solutions
	},
	setServiceRequests(state,serviceRequests){
		state.serviceRequests = serviceRequests
	},
}
const actions = {
	openAiSearch(context, item){
		if (item.userContent.trim() == "" ) {
			return
		}
		console.log('entering api.openAiSearch')
		context.dispatch("initData")
		state.searchLoading = true  
		state.userQuery = item.userContent
    state.type = item.type ? item.type:''
    state.loadingNum =  state.loadingNum + 1
		api.openAiSearch(item).then((res) => {
      state.loadingNum =  state.loadingNum -1 
      if(state.loadingNum === 0) {
        context.commit("setSearchLoading",false)
        context.commit("setSolutions",res.data.data.solutionExamples)
        context.commit("setServiceRequests",res.data.data.serviceRequests)
        context.commit("setOpenAiSolution",res.data.data.openAiResult.solution.message.content)
        context.commit("setOpenAiQuestions",res.data.data.openAiResult.questions.message.content)
        state.estimateQuestion = res.data.data.question
      }
		}, (err) => {
      state.loadingNum =  state.loadingNum -1 
      if(state.loadingNum === 0) {
        context.commit("setSearchLoading",false)
      }
      console.log(err);
    })
	},
	initData(context){
		state.searchLoading = false 
		state.userQuery = ''
		state.openAiSolution =''
		state.openAiQuestions =''
		state.openAiSearchResult = []
		state.serviceRequests=[]
		state.solutions =[]
		// state.estimateQuestion =''
    state.type =''
	}
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
	actions
}